import { Link } from 'react-router-dom';
import { routes } from 'utils/router';
import collection from 'assets/img/collection-icon.png';
import changeIcon from 'assets/img/change-icon.png';
import cn from 'classnames';
import './collectionLink.styl';
import { observer } from 'mobx-react-lite';
import { useStoreContext } from 'store/app';
import { useTranslationsContext } from 'store/translations';
import { GreenDot } from 'components/core/GreenDot';

interface Props {
    className?: string;
    selectedSnake?: number;
}

export const CollectionLink = observer(({ className, selectedSnake }: Props) => {
    const { userState, isCollectionFinished, logOperation, isMainPartFinished } = useStoreContext();
    const { translate } = useTranslationsContext();
    const hasDuplicates = userState?.free_snakes && userState?.free_snakes.length > 0;

    return (
        <Link
            className={cn('collection', className)}
            to={routes.collection}
            state={{ selectedSnake }}
            onClick={() => {
                logOperation('main_page', 'click', 'collections');
            }}
            id="collection-link"
        >
            {hasDuplicates && !isCollectionFinished && !isMainPartFinished ? (
                <>
                    <GreenDot isVisible />
                    <span className="collection-label">{translate('button.change.and.collect')}</span>
                    <img className="collection-icon-change" src={changeIcon} />
                </>
            ) : (
                <>
                    <img className="collection-icon" src={collection} />
                    <span className="collection-label">{translate('button.my.collection')}</span>
                </>
            )}
        </Link>
    );
});
